import { type Variants } from 'framer-motion';

// TODO: Unable to define `Transition` styles in this file,
// because we pull "animation values" from the theme hook.

const Y_OFFSET = 20;

export enum DrawerVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const drawerVariants: Variants = {
    [DrawerVariant.Hidden]: {
        opacity: 0,
        translateY: Y_OFFSET,
    },
    [DrawerVariant.Show]: {
        opacity: 1,
        translateY: 0,
    },
};

export enum BackdropVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const backdropVariants: Variants = {
    [BackdropVariant.Hidden]: {
        opacity: 0,
    },
    [BackdropVariant.Show]: {
        opacity: 1,
    },
};
